#import '../queries/SentenceGroupDetails.graphql'
mutation AddSentenceGroupToBarMitzvah($sentenceGroup: ID!, $barMitzvah: String!) {
  addSentenceGroupToBarMitzvah(sentenceGroup: $sentenceGroup, barMitzvah: $barMitzvah) {
    ok
    errors
    sentenceGroup {
      ...sentenceGroupDetails
    }
  }
}
